import { useTranslation } from 'react-i18next';

import { BookingStatisticsContainer } from '~features/statistics';

import Page from '../page';

const BookingStatisticsPage = () => {
	const { t } = useTranslation();

	return (
		<Page title={`${t('data')} ${t('ui.category.bookings')}`}>
			<BookingStatisticsContainer />
		</Page>
	);
};

export default BookingStatisticsPage;
